/**
 * Crea y exporta una constante equivalente al EnumEstadoInventarioProducto del DAL
 */
export const EnumEstadoInventarioProducto = {

  INVENTARIO: {codigoEstado: 1, nombre: "En inventario"},
  FUERA_INVENTARIO: {codigoEstado: 2, nombre: "Fuera de inventario"},
  PROXIMAMENTE: {codigoEstado: 3, nombre: "Próximamente"},
  PRODUCCION_SUSPENDIDA: {codigoEstado: 4, nombre: "Producción suspendida"},
}